import { iGameTemplate, iSquareSaved } from "../context/interfaces";

export const searchVertical = (matrix: iSquareSaved[][], template: iGameTemplate, clueNumber: string, clueText: string, orientation: "horizontal" | "vertical") => {
  for (let column = 0; column < matrix[0].length; column++) {
    for (let row = 0; row < matrix.length; row++) {
      if (matrix[row][column]?.palavraVertical !== -1) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //console.log('Avaible house vertical at',row,'-',column,': ', matrix[row][column]);
          clueNumber = matrix[row][column].palavraVertical.toString();
          orientation = "vertical";
          clueText = template.chaves.vertical[matrix[row][column].palavraVertical.toString()][0].chave;
          return { clueNumber, clueText, orientation, focusedHouse: { column, row } };
        }
      }
    }
  }
  return false;

}

export const searchHorizontal = (matrix: iSquareSaved[][], template: iGameTemplate, clueNumber: string, clueText: string, orientation: "horizontal" | "vertical") => {
  for (let row = 0; row < matrix.length; row++) {
    for (let column = 0; column < matrix[row].length; column++) {
      if (matrix[row][column]?.palavraHorizontal !== -1) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //We have a avaible house
          //console.log('Avaible house horixontal at',row,'-',column,': ', matrix[row][column]);
          clueNumber = matrix[row][column]?.palavraHorizontal.toString();
          clueText = template.chaves.horizontal[matrix[row][column]?.palavraHorizontal.toString()][0].chave;
    
          return { clueNumber, clueText, orientation, focusedHouse: { column, row } };
        }
      }
    }
  }
  return false;
}
export const searchHorizontalReverse = (matrix: iSquareSaved[][], template: iGameTemplate, clueNumber: string, clueText: string, orientation: "horizontal" | "vertical") => {
  //search horizontal reverse direction
  for (let row = matrix.length - 1; row >= 0; row--) {
    for (let column = matrix[row].length - 1; column >= 0; column--) {
      if (matrix[row][column]?.palavraHorizontal !== -1) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //We have a avaible house
          //console.log('Avaible house horixontal at',row,'-',column,': ', matrix[row][column]);
          clueNumber = matrix[row][column].palavraHorizontal.toString();
          clueText = template.chaves.horizontal[matrix[row][column].palavraHorizontal.toString()][0].chave;

          return { clueNumber, clueText, orientation, focusedHouse: { column, row } };
        }
      }
    }
  }
  return false;
}
export const searchVerticalReverse = (matrix: iSquareSaved[][], template: iGameTemplate, clueNumber: string, clueText: string, orientation: "horizontal" | "vertical") => {
  //search vertical reverse direction
  for (let column = matrix[0].length - 1; column >= 0; column--) {
    for (let row = matrix.length - 1; row >= 0; row--) {
      if (matrix[row][column]?.palavraVertical !== -1) {
        if (matrix[row][column]?.letra === null || matrix[row][column]?.letra === '') {
          //We have a avaible house
          //console.log('Avaible house horixontal at',row,'-',column,': ', matrix[row][column]);
          clueNumber = matrix[row][column].palavraVertical.toString();
          clueText = template.chaves.vertical[matrix[row][column].palavraVertical.toString()][0].chave;

          return { clueNumber, clueText, orientation, focusedHouse: { column, row } };
        }
      }
    }
  }
  return false;
}
